import { render, staticRenderFns } from "./recordproc.vue?vue&type=template&id=54d0e430&scoped=true&"
import script from "./recordproc.vue?vue&type=script&lang=js&"
export * from "./recordproc.vue?vue&type=script&lang=js&"
import style0 from "./recordproc.vue?vue&type=style&index=0&id=54d0e430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0e430",
  null
  
)

export default component.exports